import { TeamMargin } from 'modules/domain/teams/types'
import { AntdTable, Progress } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { useTeamColumns } from 'views/pages/Teams/useTeamColumns'

interface Props {
  teamsData: TeamMargin[]
  progress: Progress
}

export const SellerTable: FC<Props> = ({ progress, teamsData }) => {
  const columns = useTeamColumns()

  return (
    <AntdTable
      columns={columns}
      data={teamsData}
      progress={progress}
      disablePagination={true}
      tableLayout="auto"
      outerBordered
      rowKey="team"
    />
  )
}
